/**
 * @generated SignedSource<<e43f37f529ddb343502d841376890353>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoDetailScreenHeader_todoWorkspace$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainContent_Todo" | "WorkspaceTodoEditMainExpireSelector_Todo" | "WorkspaceTodoEditMainPrioritySelector_Todo" | "WorkspaceTodoEditMainProducts_TodoWorkspace" | "WorkspaceTodoEditMainPushNotification_todoWorkspace" | "WorkspaceTodoEditMainResponseType_TodoWorkspace">;
  readonly " $fragmentType": "WorkspaceTodoDetailScreenHeader_todoWorkspace";
};
export type WorkspaceTodoDetailScreenHeader_todoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoDetailScreenHeader_todoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoDetailScreenHeader_todoWorkspace">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoDetailScreenHeader_todoWorkspace",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoEditMainContent_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoEditMainProducts_TodoWorkspace"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoEditMainExpireSelector_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoEditMainPrioritySelector_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoEditMainResponseType_TodoWorkspace"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoEditMainPushNotification_todoWorkspace"
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};

(node as any).hash = "ad906c31ec1ecd85391c94625b02a547";

export default node;
